import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMedicalCross: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMedicalCross"><Path fillRule="evenodd" clipRule="evenodd" d="M8.5 2.5L8.5 8.5H2.5L2.5 15.5L8.5 15.5L8.5 21.5L15.5 21.5L15.5 15.5L21.5 15.5L21.5 8.5L15.5 8.5L15.5 2.5L8.5 2.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconMedicalCross;
